import { Router } from '@angular/router';
import { ObjectNames } from './../../../shared/constants';
import { GlobalSearchPath } from './../../../modules/shared/constants/global-search-path';
import { LocalDatePipe } from './../../../modules/shared/pipes/local-date.pipe';
import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import * as FileSaver from 'file-saver';
import {jsPDF} from 'jspdf';
import autoTable from 'jspdf-autotable';
@Component({
  selector: 'app-q-by-channel',
  templateUrl: './q-by-channel.component.html',
  styleUrls: ['./q-by-channel.component.scss'],
  providers: [LocalDatePipe]
})
export class QByChannelComponent implements OnInit, OnChanges {

  @Input() questionnaireData: any = null;
  @Input() dateFilterLabel: string = "All Time";

  questionAns: any[] = [];

  selectedAnswer;
  selectedAnswer2;
  displayAnswer = false;
  questionTemp;
  showSubQue = false;
  displayAttachmentResponses: boolean = false;
  tempAttachments: any[] = [];
  tempAnswerResponse: any = null;
  displayAnswerResponses: boolean = false;
  questionTempResponse;
  questionnaireResponseCols: any[] = [];

  questionnaireDetailCols: any[] = [];
  selectedTemplateDetails: any = null;

  paths = GlobalSearchPath;
  objectNames = ObjectNames;
  selectedTabIndex: number = 0;
  options: any;

  constructor(
    private router: Router,
    public localDatePipe: LocalDatePipe
  ) { }

  ngOnInit(): void {
    this.options = {
        onHover: (event, chartElement) => {
            const target = event.native ? event.native.target : event.target;
            target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        }
      }
    this.questionnaireDetailCols = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
        { field: 'name', header: 'Questionnaire Name', show: true, value: '', checked: true, order: false },
        { field: 'objectType', header: 'Module', show: true, value: '', checked: true, order: false },
        { field: 'channelName', header: 'Channel Name', show: true, value: '', checked: true, order: false },
        { field: 'activityTypes', header: 'Activity Type', show: true, value: '', checked: true, order: false },
        { field: 'queNo', header: 'Total Questions',show: true, value: '', checked: false, order: false },
        { field: 'totalResponseCount', header: 'Total Answered',show: true, value: '', checked: false, order: false },
        { field: 'validFromDate', header: 'Valid From', show: true, value: '', checked: false, order: false },
        { field: 'validToDate', header: 'Valid To', show: true, value: '', checked: true, order: false },
    ];

    this.questionnaireResponseCols = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false },
        { field: 'answerDate', header: 'Date', show: true, value: '', checked: true, order: false },
        { field: 'userName', header: 'Rep Name', show: true, value: '', checked: false, order: false },
        { field: 'visitType', header: 'Activity Type', show: true, value: '', checked: false, order: false },
        { field: 'storeName', header: 'Name', show: true, value: '', checked: true, order: false },
        { field: 'answerValue', header: 'Answer', show: true, value: '', checked: true, order: false },
        { field: 'comment', header: 'Comment', show: true, value: '', checked: false, order: false },
      ];
  }


  ngOnChanges(changes: SimpleChanges){
    if(changes.questionnaireData && changes.questionnaireData.currentValue){
        this.questionnaireData.objectType = this.questionnaireData?.associatedModuleName||'';
        this.selectedTemplateDetails =  {
            id: this.questionnaireData.id,
            name: this.questionnaireData.name,
            objectType: this.questionnaireData?.associatedModuleName||'',
            channelName: this.questionnaireData?.associatedModuleChanneName||'',
            typeName: this.questionnaireData?.associatedModuleChanneName||'',
            activityTypes: this.questionnaireData?.activityTypes||'',
            queNo: this.questionnaireData?.questions?.length||0,
            createdBy: this.questionnaireData?.createdByName,//this.app.currentUser.username,
            createdDate: this.localDatePipe.transform(this.questionnaireData.createdDate, 'date'),
            validFromDate: this.questionnaireData.effectiveFrom ? this.localDatePipe.transform(this.questionnaireData.effectiveFrom) : null,
            validToDate: this.questionnaireData.effectiveTo ? this.localDatePipe.transform(this.questionnaireData.effectiveTo) : null,
            totalResponseCount: this.questionnaireData?.totalResponseCount||0
          };

        const questionnaireChartData = this.questionnaireData;
        if(questionnaireChartData?.questions?.length>0){
            const questions = [];
            questionnaireChartData.questions.map((questionData, index)=>{

                const {subQuestions, ...question} = questionData;

                question.questionNo = `Q${index+1}`;
                question.responseCount = question?.questionAns?.length||0;
                question.questionOptions?.map(option=>{
                    option.answerValue = option.value;
                });

                subQuestions?.map((subQuestion, subIndex)=>{
                    subQuestion.questionNo = `Sub.Q${index+1}.${subIndex+1}`;
                    subQuestion.responseCount = subQuestion?.questionAns?.length||0;
                    subQuestion.questionOptions?.map(option=>{
                        option.answerValue = option.value;
                    });
                });

                questions.push(question);
                subQuestions?.length && questions.push(...subQuestions);
            });
            questionnaireChartData.questions = questions;
        }
        this.questionnaireData = questionnaireChartData;
        this.generateReports();
    }
  }

  generateReports(){
    this.questionAns = [];

    const sortedQuestion = this.questionnaireData?.questions?.sort((a, b) => (a.responseCount > b.responseCount) ? - 1 : 1);
    const totalResponseCount = sortedQuestion?.length>0 ? sortedQuestion[0].responseCount : 0;
    this.questionnaireData['totalResponseCount'] = totalResponseCount;
    this.questionnaireData?.questions?.map(question=>{

            question['dataSheet'] = {
                labels: [this.dateFilterLabel],
                datasets: [],
                answerValues: []
            };

            question['pieData'] = {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                        answerValues: []
                    }
                ]
            }

            if((!question?.questionOptions || question?.questionOptions?.length==0) && question.questionTypeId == 7){
                question.questionOptions = [];

                for (let index = 1; index <=5; index++) {
                    const responses = question?.questionAns?.filter(ans=>ans.answerValue==index)||[];

                    const response = {
                        answerValue: index,
                        id: index,
                        questionId: question.id,
                        responseCount: responses.length
                    }
                    question.questionOptions.push(response);
                }

            }

            if(question?.questionOptions?.length>0){

                question?.questionOptions.map((ans,index)=>{
                    ans["backgroundColor"] =  this.getColor(index);
                    ans["hoverBackgroundColor"] =  this.getColor(index);
                });

                question.questionOptions = question?.questionOptions.sort((a, b) => (a.responseCount > b.responseCount) ? - 1 : 1);

                //Pie Data
                let notAnswered = totalResponseCount - question?.totalresponsecount;
                notAnswered = notAnswered < 0 ? 0 : notAnswered;
                //Pie Data
                let pieResonse = (totalResponseCount>0 && notAnswered>0) ? (notAnswered*100)/totalResponseCount : 0;
                    pieResonse = parseFloat(pieResonse.toFixed(1));

                question.pieData.labels.push(`Not answered (${notAnswered})`);
                question.pieData.datasets[0].data.push(pieResonse);
                question.pieData.datasets[0].backgroundColor.push("#d8dadd");
                question.pieData.datasets[0].hoverBackgroundColor.push("#c1c4c9");
                question.pieData.datasets[0].answerValues.push("Not answered");

                question?.questionOptions?.map((dropdownList, index)=>{

                    //Bar Data
                    let sets = {
                        id: dropdownList.id,
                        label: `${dropdownList.answerValue}`,
                        backgroundColor: dropdownList.backgroundColor,
                        data: [dropdownList.responseCount],
                        answerValues: [dropdownList.answerValue]
                    }
                    question.dataSheet.datasets.push(sets);


                    //Pie Data
                    let pieResonse = (totalResponseCount>0 && dropdownList.responseCount>0) ? (dropdownList.responseCount*100)/totalResponseCount : 0;
                    pieResonse = parseFloat(pieResonse.toFixed(1));

                    question.pieData.labels.push(`${dropdownList.answerValue} (${dropdownList.responseCount})`);
                    question.pieData.datasets[0].data.push(pieResonse);
                    question.pieData.datasets[0].backgroundColor.push(dropdownList.backgroundColor);
                    question.pieData.datasets[0].hoverBackgroundColor.push(dropdownList.hoverBackgroundColor);
                    question.pieData.datasets[0].answerValues.push(dropdownList.answerValue);
                });
            }



            if(question.questionTypeId == 5 || question.questionTypeId == 6 || question.questionTypeId == 8){

                let notAnswered = totalResponseCount - question?.totalresponsecount;
                notAnswered = notAnswered < 0 ? 0 : notAnswered;

                //Pie Data
                let pieResonse = (totalResponseCount>0 && notAnswered>0) ? (notAnswered*100)/totalResponseCount : 0;
                    pieResonse = parseFloat(pieResonse.toFixed(1));

                let pieAnsResonse = (totalResponseCount>0 && question?.totalresponsecount>0) ? (question?.totalresponsecount*100)/totalResponseCount : 0;
                    pieAnsResonse = parseFloat(pieAnsResonse.toFixed(1));

                question['pieData'] = {
                    labels: [`Not answered (${notAnswered})`,`Answered (${question?.totalresponsecount})`],
                    datasets: [
                        {
                            data: [pieResonse,pieAnsResonse],
                            backgroundColor: ['#d8dadd','#FFA726'],
                            hoverBackgroundColor: ['#c1c4c9','#FFA726'],
                            answerValues: ['Not answered','Answered'],
                            answerValueIds: [0,1]
                        }
                    ]
                }
            }


        this.questionAns.push(question);
    });
  }

  getColor(index){

    const colorList = ['#42A5F5','#FFA726','#7E57C2','#26A69A',"#FF6384","#36A2EB"];

    if(index>5){
        let i = index%5;
        return colorList[i];
    }else{
        return colorList[index];
    }
  }

  showAnswer(q){
    this.questionTemp = JSON.parse(JSON.stringify(q));
    this.selectedTabIndex = 0;
    this.onDataSelect(null,q);
    this.displayAnswer = true;
  }

  onDataSelect($event=null,data,chart='bar'){

    this.questionTempResponse = JSON.parse(JSON.stringify(data));
    let clickAnswerIndex = 0;
    let dataSet: any = null;
    let answerValue: string = "";
    if($event!=null){
        if(chart=='bar'){
            clickAnswerIndex = $event.element.datasetIndex;
            dataSet = this.questionTempResponse.dataSheet.datasets[clickAnswerIndex];
            answerValue = dataSet.answerValues[0]+"";
        }else{
            clickAnswerIndex = $event.element.index;
            dataSet = this.questionTempResponse.pieData.datasets[0].answerValues[clickAnswerIndex];
            answerValue = dataSet+"";
        }
    }

    this.questionTempResponse["answerValue"] = answerValue;
    this.questionTempResponse["totalresponsecount"] = 0;

    if(answerValue && this.questionTempResponse.questionAns?.length>0){
        this.questionTempResponse.questionAns = this.questionTempResponse.questionAns.filter(questionAns=>{
            let answerList = questionAns.answerValue.split(",");

            if(answerValue=="Answered" || answerList.includes(answerValue)){

                questionAns.answerDate =  this.localDatePipe.transform(questionAns.answerDate);
                questionAns['objectType'] = this.questionnaireData.objectType;

                if(this.questionTempResponse.questionTypeId == 6){
                    questionAns.answerValue = `${questionAns?.qAttachment?.length||0} attachment${questionAns?.qAttachment?.length>1?"'s":""} added`;
                }


                if(this.questionTempResponse.questionTypeId == 5){
                    questionAns.answerValue = `${questionAns?.qAttachment?.length||0} image${questionAns?.qAttachment?.length>1?"'s":""} added`;
                }

                return true
            }

            return false;
        });

        this.questionTempResponse.questionAns =   this.questionTempResponse.questionAns.length>0? this.questionTempResponse.questionAns.reverse() : [];

        this.questionTempResponse.totalresponsecount = this.questionTempResponse.questionAns.length;

        this.displayAnswerResponses = true;
    }else{
        this.questionTempResponse.questionAns?.map(questionAns=>{
            questionAns.answerDate =  this.localDatePipe.transform(questionAns.answerDate);
            questionAns['objectType'] = this.questionnaireData.objectType;

            if(this.questionTempResponse.questionTypeId == 6){
                questionAns.answerValue = `${questionAns?.qAttachment?.length||0} attachment${questionAns?.qAttachment?.length>1?"'s":""} added`;
            }


            if(this.questionTempResponse.questionTypeId == 5){
                questionAns.answerValue = `${questionAns?.qAttachment?.length||0} image${questionAns?.qAttachment?.length>1?"'s":""} added`;
            }
        });


        this.questionTempResponse.questionAns =   this.questionTempResponse.questionAns?.length>0? this.questionTempResponse.questionAns.reverse() : [];
        this.questionTempResponse.totalresponsecount = this.questionTempResponse.questionAns.length;
    }

  }

  setDataDetails(data) {
    let url = '';
    let moduleType = "";

    if (data.objectType == 'Account') {
        url = this.paths.Account;
        moduleType = this.objectNames.ACCOUNT;
    } else if (data.objectType == 'Lead') {
        url = this.paths.Lead;
        moduleType = this.objectNames.LEADS;
    }

    const queryParams = {
        id: data.storeId,
        module: moduleType,
        statusId: 1,
        globalSearch: true,
        data: data.storeName
    };

    // if (moduleType === this.objectNames.LEADS || this.moduleType === this.objectNames.ACCOUNT) {
    //     queryParams['channelId'] = this.data.typeId;
    //     queryParams['data'] = this.data.businessName;
    // }

    this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() =>
            this.router.navigate([url], {
                queryParams
            })
        );
  }

  viewAddedAttachments(questionAns){
    this.tempAnswerResponse = questionAns;
    this.tempAttachments = questionAns?.qAttachment || [];

    this.displayAttachmentResponses = true;
  }

  openResponsesAsPDF(showOptions: boolean = false) {
    let doc = new jsPDF('l', 'mm', [315.9, 379.4]);

    let pdfcolumns = [];
    this.questionnaireResponseCols.map(cols=>{
        if(cols.show)pdfcolumns.push({ dataKey: cols.field, header: cols.header })
    })

    let dataResult = this.questionTempResponse?.questionAns||[];

    let pdfTopcolumns = [];
    this.questionnaireDetailCols.map(cols=>{
        if(cols.show)pdfTopcolumns.push({ dataKey: cols.field, header: cols.header })
    });

    let topDataResult = [{...this.selectedTemplateDetails}];
    let startY = 15;
    autoTable(doc, {
        theme: 'grid',
        startY: startY,
        body: topDataResult.length ? topDataResult : [],
        columns: topDataResult.length ? pdfTopcolumns : [""],
        showHead: 'everyPage',
        tableLineColor: "#FFF",
        headStyles: {
            fontSize: 10,
            textColor: "#000",
            fillColor: "#FFF",
            halign: "center"
        },
        styles: {
            lineColor: "#FFF",
            fontSize: 10,
            minCellHeight: 8,
            cellWidth: "wrap",
            halign: "center"
        }
    });

    startY += 30;
    doc.setFontSize(12);
    doc.text(`Q: ${this.questionTempResponse?.name}`, 13, startY);


    if(!showOptions){
        startY += 10;
        doc.setFontSize(10);
        doc.text(`Ans: ${ this.questionTempResponse?.answerValue } (${ this.questionTempResponse?.totalresponsecount })`, 13, startY);
    }else{
        this.questionTemp?.questionOptions?.map((options, i)=>{
            startY += 7;
            doc.setFontSize(10);
            doc.text(`${i+1}. ${options?.answerValue} (${ options?.responseCount })`, 13, startY);
        })
    }

    startY += 10;
    autoTable(doc, {
        theme: 'grid',
        startY: startY,
        body: dataResult.length ? dataResult : [],
        columns: dataResult.length ? pdfcolumns : ["No response available."],
        showHead: 'everyPage',
        styles: {
            fontSize: 10,
            minCellHeight: 8,
            minCellWidth: 40,
            cellWidth: "auto"
        }
    });

    window.open(URL.createObjectURL(doc.output("blob")));
}

 downloadAsXLS() {
    let dataResult = [];
    let reportName = this.questionTempResponse?.name;

    this.questionTempResponse?.questionAns.map(rowData=>{
        let obj = {};

        this.questionnaireResponseCols.map(cols=>{
            if(cols.show){obj[cols.header] = rowData[cols.field]};
        });

        if(obj){
            dataResult.push(obj);
        }
    })

    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(dataResult);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
        this.saveAsExcelFileXLS(excelBuffer, reportName);
    });
  }

  saveAsExcelFileXLS(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xls';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  changeTab(e){
        let index = e.index;
        this.selectedTabIndex = index;
  }

}
